<template>
    <div>
        <public-head title="历年分数"></public-head>
        <div class="header">
            <div
                :class="currentData == 0 ? 'active' : ''"
                @click="tabClick(0)"
            >院校分数线</div>
            <div
                :class="currentData == 1 ? 'active' : ''"
                
                @click="tabClick(1)"
            >专业分数线</div>
            <!-- <div class="{{currentData == 2 ? 'active' : ''}}" data-current="2" bindtap="tabClick">招生计划</div> -->
        </div>
        <!-- 搜索 -->
        <div class="select">
            <!-- 下拉框 -->
            <div class="select-wrap" @click="bindcourse">
                <div>{{course.name}}</div>
                <!-- 下拉需要显示的列表 -->
                <div class="course" v-if="select">
                    <div v-for="(item,index) in course_type" :key="index">
                        <div
                            class="course-item"
                            @click="selectCourse(item)"
                           
                        >{{item.name}}</div>
                    </div>
                </div>

                <div class="triangle" v-if="course_type.length>0"></div>
            </div>
            <div class="year select-wrap" @click="bindyear" v-if="currentData!=0">
                <div>{{year.name}}</div>
                <div class="course" v-if="select1">
                    <div v-for="(item,index) in year_type" :key="index">
                        <!-- data-id="{{item.id}}"
                            data-name="{{item.name}}" -->
                        <div
                            class="course-item"
                            @click="selectYear(item)"                            
                        >{{item.name}}</div>
                    </div>
                </div>

                <div class="triangle" v-if="year_type.length>0"></div>
                <!--三角形-->
            </div>
            <div class="grade select-wrap" @click="bindbatch" v-if="currentData!=0">
                <div>{{batch.name}}</div>
                <div class="course" v-if="select2">
                    <div v-for="(item,index) in batch_type" :key="index">
                        
                        <div
                            class="course-item"
                            @click="selectBatch(item)"
                            
                        >{{item.name}}</div>
                    </div>
                </div>

                <div class="triangle" v-if="batch_type.length>0"></div>
            </div>
        </div>
        <!-- 信息列表展示 -->
        <div class="table" v-if="currentData!=1">
            <div class="condition">
                <div style="width:28%;">招生批次</div>
                <div>最高分/平均分</div>
                <div>最低分/最低位次</div>
                <div>录取数</div>
            </div>
            <div :class="['s-tr' ,index%2==0?'bg':'']" v-for="(item,index) in school_score" :key="index">
                <div>
                    <div class="th">{{item.year}}</div>
                    <div class="th">{{item.course_type}} {{item.batch}}</div>
                </div>
                <div class="td">
                    <div class="th">{{item.max_score}}</div>
                    <div class="th">{{item.avg_score}}</div>
                </div>
                <div class="td">
                    <div class="th">{{item.min_score}}</div>
                    <div class="th">{{item.low_sort}}</div>
                </div>
                <div class="td" style="width:10%;">{{item.enter_num}}</div>
            </div>
        </div>
        <div class="table" v-if="currentData!=0">
            <div class="condition">
                <div style="width:31%;">专业名称</div>
                <div>最低分/最低位次</div>
                <div>录取数</div>
            </div>
            <div :class="['s-tr' ,index%2==0?'bg':'']" v-for="(item,index) in career_score" :key="index">
                <div class="td" style="width:31%;">{{item.major_name}}</div>
                <div class="td">
                    <div class="th">{{item.min_score}}</div>
                    <div class="th">{{item.low_sort}}</div>
                </div>
                <div class="td" style="width:10%;">{{item.enter_num}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { httpPost, httpGet } from "../../../../axios/index";
import PublicHead from "../../../../components/publicHead";

export default {
    name: "schoolInfo",
    data() {
        return {
            year_type:"",
            course_type:"",
            batch_type:"",
            currentData: 0, //当前页面
            batch: {}, //批次
            course: {
            }, //文理
            year: {
            },
            school_score: [],
            career_score: [],
            select: false,
            select1: false,
            select2: false,
            };
    },
    methods: {
        // bindcourse(){},
        // bindyear(){},
        // bindbatch(){},
        loadOption() {
            httpPost("/School/condition_socre", {
                id: 1,//this.$store.state.schooId,
                province: this.$store.state.areaInfo.pid
            }).then(response => {
                if (response.code === 1) {
                  
                    this.batch_type= response.batch_type, //本专科
                    this.course_type= response.course_type, //文理科
                    this.year_type= response.year_type
                    //  展示学校应有的搜索条件,并赋值默认搜索条件
                    let batch = {}
                    batch.id = this.batch_type[0].id
                    batch.name = this.batch_type[0].name
                    let course = {}
                    course.id = this.course_type[0].id
                    course.name = this.course_type[0].name
                    let year = {}
                    year.id = this.year_type[0].id
                    year.name = this.year_type[0].name                  
                        this.batch= batch,
                        this.course= course,
                        this.year= year 
                }
            });
        },
         schoolScore(course) {
        httpPost(
             '/School/details_three',
            {
                id:this.$route.query.id,
                province: this.$store.state.areaInfo.pid,
                course: course,
            }).then(res=>{
               
                if(res.code===1){
                     this.school_score= res.school_score
                }
            })            
    },
    majorScore(batch, course, year) {
       httpPost(
           '/School/details_four',
           {
                id: 1,//this.$store.state.schooId,
                province: this.$store.state.areaInfo.pid,
                batch: batch,
                course: course,
                year: year
            }).then(res=>{
               
                if(res.code===1){
                    this.career_score= res.career_score
                }
            }) 
    },
    selectCourse(e) {
       
        var name = e.name;
        var id = e.id;
        var obj = {};
        obj.id = id;
        obj.name = name;
        this.course= obj
        this.loadData()
    },
    selectBatch(e) {
        var name = e.name;
        var id = e.id;
        var obj = {};
        obj.id = id;
        obj.name = name;
         this.batch=obj
        this.loadData()
    },
    selectYear(e) {
       
        var name = e.name;
        var id = e.id;
        var obj = {};
        obj.id = id;
        obj.name = name;      
        this.year= obj
        this.loadData()
    },
    //根据所在页面不同，加载不同数据
    loadData() {
        this.schoolScore(this.course.id);
        this.majorScore(this.batch.id, this.course.id, this.year.name);
        // this.enrollPlan(this.batch.id, this.course.id, this.year.name)

    },
    // 点击切换页面
    tabClick: function (e) {
      
        if (this.currentData === e) {
            return false;
        } else {
                this.currentData= e
        }
    },
    // 下拉框
    // 点击下拉显示框
    bindcourse() { 
            this.select= !this.select
    },
    bindyear() {
            this.select1= !this.select1
    },
    bindbatch() {  
            this.select2= !this.select2
    },
       
    },
    mounted() {
        this.loadOption();
        let year = new Date().getFullYear();
        this.schoolScore(this.course.id);
        this.majorScore(this.batch.id, this.course.id, this.year.name);
        if (this.$route.query.id == 2) {
                currentData: 2
        }
    },
     components:{
            PublicHead
        }
};
</script>

<style scoped>
/* pages/tabBar/school/scores/scores.wxss */

/* 固定 */

.header {
    display: flex;
    justify-content: space-around;
    height: 3.125rem;
    line-height: 3.125rem;
    font-size: 1rem;
    color: #777;
    margin-top: 46px;
}

.active {
    font-size: 1.125rem;
    font-weight: bold;
    color: #74dbd3;
}

.select {
    display: flex;
    height: 3.125rem;
    background-color: #eee;
    font-size: 0.875rem;
    padding-left: 0.625rem;
}

/*  */

.select-wrap {
    height: 1.875rem;
    line-height: 1.875rem;
    border-radius: 1.125rem;
    background-color: #fff;
    /* div-align: center; */
    margin: 0.625rem 0.625rem;
    position: relative;
    box-sizing: border-box;
    padding-left: 0.9375rem;
    padding-right:1.4375rem;
}

/*文理科选择下拉*/

.course {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    background: #fff;
    box-shadow: 0 2px 2px 2px #ccc;
    padding: 0.1875rem;
    border-radius: 0.125rem;
}

/* 表 */

/* .hidden{
    display: none;
} */

.condition {
    box-sizing: border-box;
    padding: 0 0.9375rem;
    height: 2.8125rem;
    line-height: 2.8125rem;
    font-size: 0.875rem;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    color: #777;
}

.bg {
    background: #f2f2f2;
}

.s-tr {
    box-sizing: border-box;
    padding: 0.9375rem;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    font-size: 0.875rem;
}

.th {
    display: flex;
    flex-wrap: wrap;
}

.th {
    /* div-align: center; */
    display: block
}
.td{
    display: flex;
    flex-flow: column;
    justify-content: center;
}
/* 下拉 */
.top {
    width: 100vw;
    height: 2.5rem;
    padding: 0 0.625rem;
    line-height: 2.5rem;
    font-size: 1.125rem;
    border-bottom: 1px solid #000;
}

.top-div {
    float: left;
}

.triangle {
    width: 0;
    height: 0;
    border-width: 0.3125rem;
    border-style: solid;
    border-color: #ccc transparent transparent transparent;
    position: absolute;
    right: 0.625rem;
    top: 0.3125rem;
    bottom: 0;
    margin: auto 0;
}

</style>